/* Discovery-only runtime. Server config is not an authorization mechanism. Liquid endpoint guards remain required. */
(() => {
  'use strict';
  if (window.swDiscoveryRuntime) return;
  const node = document.querySelector('script[data-discovery-runtime]');
  if (!node) return;
  let c;
  try { c = JSON.parse(node.textContent); } catch (_) { return; }
  // Release requires an explicit reviewed code change, never a query parameter.
  const RELEASE_ENABLED = true;
  const RELEASE_THEME = '186421346577';
  const draft = c.themeId === '186421346577' && c.themeRole === 'unpublished';
  const production = RELEASE_ENABLED && RELEASE_THEME !== '0' && c.themeId === RELEASE_THEME && c.themeRole === 'main';
  const pathname = location.pathname.replace(/\/$/, '');
  const genuine = c.pageHandle === 'discover' && pathname === '/pages/discover';
  const harness = draft && c.harness === true && c.pageHandle === 'terms' && pathname === '/pages/terms';
  if (!c.enabled || c.pageType !== 'page' || !(genuine || harness) || !(draft || production)) return;
  const suffix = draft ? '-qa' : '';
  const themeId = c.themeId, themeRole = c.themeRole;
  function url(path) {
    const value = new URL(path, location.origin);
    if (value.origin !== location.origin || value.search || value.hash) throw Error('Discovery endpoint path');
    if (draft) value.searchParams.set('preview_theme_id', themeId);
    return value;
  }
  function identity(data) { return !!data && data.themeId === themeId && data.themeRole === themeRole; }
  function allowedView(view) {
    return typeof view === 'string' && (draft
      ? /^(?:sw-|discovery-)[a-z0-9-]+-qa$/.test(view)
      : /^sw-discover-(?:brand|taste|color)-[a-z0-9-]+$/.test(view) && !view.endsWith('-qa'));
  }
  window.swDiscoveryRuntime = Object.freeze({
    themeId, themeRole, mode: draft ? 'draft' : 'production', pagePath: draft ? '/pages/terms' : '/pages/discover',
    registryView: 'sw-discovery-stock-registry' + suffix,
    productStockSection: 'sw-discovery-product-stock' + suffix,
    cardSection: 'sw-discovery-card-page' + suffix,
    historyKey: 'swDiscoveryStockHistory:' + themeId + ':' + themeRole + ':discover',
    url, identity, allowedView
  });
})();
